import { configureStore, combineReducers } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import authReducer from './slices/authSlice';
import themeReducer from './slices/themeSlice';
import planReducer from './slices/planSlice';
import posCartReducer from './slices/posCartSlice';
import goldPriceReducer from './slices/goldPriceSlice';
import { onboardingReducer } from './slices/onboardingSlice';

const persistConfig = {
  key: 'erp-tenant',
  version: 1,
  storage,
  // Persist onboarding để user F5 hoặc đóng tab giữa chừng vẫn giữ draft + step.
  whitelist: ['auth', 'theme', 'posCart', 'onboarding'],
};

const rootReducer = combineReducers({
  auth: authReducer,
  theme: themeReducer,
  plan: planReducer,
  posCart: posCartReducer,
  goldPrice: goldPriceReducer,
  onboarding: onboardingReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
